import { TaskCard, type TaskCardProps } from '../task-card/TaskCard'

export const TaskGroupCard = (props: TaskCardProps) => {
  const taskIds = props.id.split(',')
  const to =
    taskIds.length === 1
      ? `/tasks/${taskIds[0]}`
      : `/task-group?ids=${props.id}`

  return <TaskCard {...props} isGrouped={true} to={to} />
}
